import axios from "axios";
import * as actionType from "../../../constant/actionType";
// import { fetchData,fetchDataSuccess, fetchDataError } from "../../redux/classes/client-portal/clientCsvSlice";
export const SubmitWorkerDocToClient = (ApiData) => async (dispatch) => {
      try {
        const response = await axios({
          method: 'post',
          data: ApiData,
          headers: {
            Authorization: `Bearer ${localStorage.getItem('conserve_authtoken')}`,
          },
          url: `${actionType.environment_url}/api/worker/SubmitWorkerDocToClient`,
        });
        return response.data
      } catch (error) {
        return error.message
      }
    }